import React, { useEffect, useState } from "react";
import { Plus, Search, Phone } from "lucide-react";
import { useCrm } from "../../pages/crm/CrmApp";
import { money, STATUS } from "../../lib/crmApi";
import { ContactForm } from "./ContactForm";
import { ContactDetail } from "./ContactDetail";

export const Contacts = () => {
  const { api, openContact, setOpenContact } = useCrm();
  const [list, setList] = useState(null);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("");
  const [form, setForm] = useState(null);
  const load = () => api(`/contacts?q=${encodeURIComponent(q)}&status=${status}`).then(setList);
  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
  }, [q, status]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900">Clientes y prospectos</h1>
        <button onClick={() => setForm({})} className="inline-flex items-center gap-1.5 rounded-full px-4 py-2.5 text-sm font-semibold text-white shadow" style={{ background: "var(--crm)" }} data-testid="crm-add-contact"><Plus className="h-4 w-4" /> Nuevo</button>
      </div>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar por nombre, empresa, teléfono…" className="w-full rounded-xl border border-slate-200 bg-white py-2.5 pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-[var(--crm)]" data-testid="crm-contact-search" />
      </div>
      <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1">
        {[["", "Todos"], ...Object.entries(STATUS).map(([k, s]) => [k, s.label])].map(([k, l]) => (
          <button key={k || "all"} onClick={() => setStatus(k)} className="shrink-0 rounded-full border px-3.5 py-1.5 text-xs font-medium" style={status === k ? { background: "var(--crm)", color: "#fff", borderColor: "transparent" } : { background: "#fff", borderColor: "#e2e8f0", color: "#475569" }} data-testid={`crm-filter-${k || "all"}`}>
            {l}
          </button>
        ))}
      </div>
      {list && !list.length && <p className="py-12 text-center text-sm text-slate-400" data-testid="crm-contacts-empty">No hay registros aún.</p>}
      <div className="grid gap-2 md:grid-cols-2">
        {(list || []).map((c) => (
          <button key={c.id} onClick={() => setOpenContact(c.id)} className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-3.5 text-left transition-shadow hover:shadow-md" data-testid={`crm-contact-${c.id}`}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white" style={{ background: STATUS[c.status]?.color }}>{c.name[0]?.toUpperCase()}</span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-semibold text-slate-900">{c.name}</span>
              <span className="block truncate text-xs text-slate-500">{[c.company, c.owner_name].filter(Boolean).join(" · ") || (c.phone && <><Phone className="mr-1 inline h-3 w-3" />{c.phone}</>)}</span>
            </span>
            <span className="text-right">
              <span className="block rounded-full px-2 py-0.5 text-[10px] font-semibold text-white" style={{ background: STATUS[c.status]?.color }}>{STATUS[c.status]?.label}</span>
              {c.value > 0 && <span className="mt-1 block text-[11px] text-slate-500">{money(c.value)}</span>}
            </span>
          </button>
        ))}
      </div>
      <ContactForm open={!!form} initial={form} onClose={() => setForm(null)} onSaved={load} />
      <ContactDetail id={openContact} onClose={() => setOpenContact(null)} onChanged={load} />
    </div>
  );
};
